import { render, staticRenderFns } from "./JobDesc.vue?vue&type=template&id=4e34bea0&scoped=true&"
import script from "./JobDesc.vue?vue&type=script&lang=js&"
export * from "./JobDesc.vue?vue&type=script&lang=js&"
import style0 from "./JobDesc.vue?vue&type=style&index=0&id=4e34bea0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e34bea0",
  null
  
)

export default component.exports